/*
 * bag-selector.js — custom CI-styled bag dropdown (one row per bag TYPE) with a
 * colour swatch sub-selector, plus cart wiring: adds the chosen bag as a separate
 * line and tags the handpan line with { _bundle, _default_bag } so
 * bag-cart-guard.js's site-wide safety net recognizes the pairing.
 *
 * Verified against the live theme ("Shop 2.0"):
 *   - the product form fires the DOM event `theme:cart:refresh` on document after
 *     a successful add (no pub/sub cartUpdate for adds here)
 *
 * REVISED (fragility fix): tagging the handpan line used to be done by setting
 * its quantity to 0 (removing it) then re-adding it with new properties, purely
 * to make it show as the "newest" cart line. If the re-add step failed after
 * the removal succeeded, the handpan vanished from the cart entirely with no
 * error shown. Properties can be updated on an existing line in place via
 * /cart/change.js (by line key) without ever removing it — the "newest line"
 * cosmetic ordering wasn't worth that failure window, so it's dropped.
 * Pricing is handled entirely by the native Buy X Get Y discounts.
 */
(function () {
  var form = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
  var root = document.querySelector('[data-bag-selector]');
  if (!form || !root) return;
  var dd = root.querySelector('[data-bag-dropdown]');
  if (!dd) return;

  var toggle = dd.querySelector('[data-bag-toggle]');
  var panel = dd.querySelector('[data-bag-panel]');
  var curName = dd.querySelector('[data-bag-current]');
  var curPrice = dd.querySelector('[data-bag-current-price]');
  var colorsWrap = dd.querySelector('[data-bag-colors]');
  var hidden = dd.querySelector('[data-bag-value]');
  var rows = Array.prototype.slice.call(dd.querySelectorAll('[data-bag-type]'));
  var rowsEnabled = rows.filter(function (r) { return r.getAttribute('aria-disabled') !== 'true'; });
  var activeEl = null;
  var selectedName = '';   // base bag-type name, for composing "Name · Colour"

  function setValue(id) { if (id) hidden.value = id; }

  // ---------- open / close ----------
  // The dropdown lives inside a theme block that gets a transform from the AOS
  // scroll animation -> that creates a stacking context which traps the panel's
  // z-index, so later blocks (Klaviyo "notify", Alma widget) paint over it.
  // Fix: while open, lift the nearest stacking-context ancestor above its siblings.
  var elevatedEl = null, prevPos = '', prevZ = '';
  function nearestStackingAncestor(el) {
    el = el.parentElement;
    while (el && el !== document.body) {
      var s = getComputedStyle(el);
      if (s.transform !== 'none' || s.filter !== 'none' || s.perspective !== 'none' ||
          (s.willChange && s.willChange.indexOf('transform') > -1) || parseFloat(s.opacity) < 1 ||
          (s.position !== 'static' && s.zIndex !== 'auto')) { return el; }
      el = el.parentElement;
    }
    return null;
  }
  function elevate(on) {
    if (on) {
      elevatedEl = nearestStackingAncestor(root) || root.closest('.product__block') || root.parentElement;
      if (!elevatedEl) return;
      prevPos = elevatedEl.style.position; prevZ = elevatedEl.style.zIndex;
      if (getComputedStyle(elevatedEl).position === 'static') elevatedEl.style.position = 'relative';
      elevatedEl.style.zIndex = '1000';
    } else if (elevatedEl) {
      elevatedEl.style.position = prevPos; elevatedEl.style.zIndex = prevZ; elevatedEl = null;
    }
  }

  function isOpen() { return dd.classList.contains('is-open'); }
  function open() {
    dd.classList.add('is-open'); panel.hidden = false; toggle.setAttribute('aria-expanded', 'true');
    elevate(true);
    setActive(panel.querySelector('.is-selected') || rowsEnabled[0]);
    setTimeout(function () { document.addEventListener('click', onOutside, true); }, 0);
  }
  function close() {
    dd.classList.remove('is-open'); panel.hidden = true; toggle.setAttribute('aria-expanded', 'false');
    elevate(false);
    document.removeEventListener('click', onOutside, true);
  }
  function onOutside(e) { if (!dd.contains(e.target)) close(); }
  function setActive(el) {
    if (!el) return;
    var prev = panel.querySelector('.is-active'); if (prev) prev.classList.remove('is-active');
    el.classList.add('is-active'); activeEl = el; el.scrollIntoView({ block: 'nearest' });
  }

  // ---------- colour sets ----------
  function colourSetFor(handle) {
    return colorsWrap ? colorsWrap.querySelector('[data-colors-for="' + handle + '"]') : null;
  }
  function showColoursFor(handle) {
    if (!colorsWrap) return null;
    var match = null;
    colorsWrap.querySelectorAll('[data-colors-for]').forEach(function (s) {
      var on = s.getAttribute('data-colors-for') === handle;
      s.hidden = !on; if (on) match = s;
    });
    colorsWrap.hidden = !match;
    return match;
  }
  function updateToggle(colourName) {
    curName.textContent = selectedName + (colourName ? ' · ' + colourName : '');
  }

  // ---------- choose a bag TYPE ----------
  function chooseType(row, keepOpenColour) {
    if (!row || row.getAttribute('aria-disabled') === 'true') return;
    var prev = panel.querySelector('.is-selected');
    if (prev) { prev.classList.remove('is-selected'); prev.setAttribute('aria-selected', 'false'); }
    row.classList.add('is-selected'); row.setAttribute('aria-selected', 'true');

    selectedName = row.getAttribute('data-name') || '';
    var isFree = row.getAttribute('data-kind') === 'free';
    curPrice.textContent = row.getAttribute('data-price') || '';
    curPrice.classList.toggle('is-free', isFree);
    setValue(row.getAttribute('data-variant'));

    // colours for this type
    var set = showColoursFor(row.getAttribute('data-handle'));
    var colourName = '';
    if (set) {
      var swatches = set.querySelectorAll('.bag-swatch');
      swatches.forEach(function (s) { s.classList.remove('is-on'); });
      var firstAvail = set.querySelector('.bag-swatch:not([data-unavailable])') || swatches[0];
      if (firstAvail) {
        firstAvail.classList.add('is-on');
        setValue(firstAvail.getAttribute('data-variant'));
        colourName = firstAvail.getAttribute('data-name') || '';
      }
    }
    updateToggle(colourName);
  }

  // ---------- choose a COLOUR ----------
  if (colorsWrap) {
    colorsWrap.addEventListener('click', function (e) {
      var sw = e.target.closest('.bag-swatch');
      if (!sw || sw.hasAttribute('data-unavailable')) return;
      var set = sw.closest('[data-colors-for]');
      set.querySelectorAll('.bag-swatch').forEach(function (s) { s.classList.remove('is-on'); });
      sw.classList.add('is-on');
      setValue(sw.getAttribute('data-variant'));
      updateToggle(sw.getAttribute('data-name') || '');
    });
  }

  // ---------- events ----------
  toggle.addEventListener('click', function (e) { e.preventDefault(); isOpen() ? close() : open(); });
  panel.addEventListener('click', function (e) {
    var li = e.target.closest('[data-bag-type]'); if (li) { chooseType(li); close(); toggle.focus(); }
  });
  panel.addEventListener('mousemove', function (e) {
    var li = e.target.closest('[data-bag-type]');
    if (li && li.getAttribute('aria-disabled') !== 'true') setActive(li);
  });
  dd.addEventListener('keydown', function (e) {
    var k = e.key;
    if (!isOpen()) {
      if (k === 'Enter' || k === ' ' || k === 'ArrowDown' || k === 'ArrowUp') { e.preventDefault(); open(); }
      return;
    }
    if (k === 'Escape' || k === 'Tab') { close(); if (k === 'Escape') { e.preventDefault(); toggle.focus(); } return; }
    if (k === 'Enter' || k === ' ') { e.preventDefault(); chooseType(activeEl); close(); toggle.focus(); return; }
    if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Home' || k === 'End') {
      e.preventDefault();
      var idx = rowsEnabled.indexOf(activeEl);
      if (k === 'Home') idx = 0;
      else if (k === 'End') idx = rowsEnabled.length - 1;
      else if (k === 'ArrowDown') idx = Math.min(rowsEnabled.length - 1, idx + 1);
      else idx = Math.max(0, idx - 1);
      setActive(rowsEnabled[idx]);
    }
  });

  // ---------- sold-out / availability handling ----------
  var errEl = root.querySelector('[data-bag-error]');
  function showError(msg) { if (errEl && msg) { errEl.textContent = msg; errEl.hidden = false; } }
  function clearError() { if (errEl) { errEl.hidden = true; } }
  function msgSoldOut() { return root.getAttribute('data-msg-bag-soldout') || 'The selected bag is sold out. Please choose another bag.'; }
  function msgNoneAvailable() { return root.getAttribute('data-msg-bags-none') || 'All bags are currently sold out.'; }

  // No purchasable bag at all -> handpans must not be buyable (they only ship
  // with a bag). Disable the submit button and hide dynamic checkout (PayPal
  // etc.), which would otherwise bypass the bag flow entirely.
  var noneAvailable = root.hasAttribute('data-bag-none-available') || rowsEnabled.length === 0;
  function setPurchasable(on) {
    var btns = form.querySelectorAll('button[type="submit"], input[type="submit"], [name="add"]');
    Array.prototype.forEach.call(btns, function (b) {
      b.disabled = !on;
      b.setAttribute('aria-disabled', String(!on));
    });
    var dyn = form.querySelector('.shopify-payment-button') || document.querySelector('.shopify-payment-button');
    if (dyn) dyn.style.display = on ? '' : 'none';
  }
  if (noneAvailable) {
    setPurchasable(false);
    showError(msgNoneAvailable());
  }

  function selectedRow() { return panel.querySelector('[data-bag-type].is-selected'); }
  function selectedAvailable() {
    var r = selectedRow();
    return !!r && r.getAttribute('aria-disabled') !== 'true';
  }

  // init from the preselected row (sets toggle text, value, colours).
  // Liquid only marks an AVAILABLE row as .is-selected; chooseType itself
  // refuses aria-disabled rows, so a sold-out free bag can never become the
  // effective selection.
  chooseType(panel.querySelector('.bag-dropdown__opt.is-selected') || rowsEnabled[0]);

  function selectedBagId() { return hidden && hidden.value ? parseInt(hidden.value, 10) : null; }

  // ---------- cart wiring ----------
  var pending = null, working = false, pendingTimer = null;

  // Only return the free bag's variant when it is actually available — a
  // sold-out variant must never end up as `_default_bag` (bag-cart-guard
  // would keep trying to re-add it, and /cart/add.js keeps 422ing).
  function freeBagId() {
    var o = dd.querySelector('[data-bag-type][data-kind="free"]');
    if (!o || o.getAttribute('aria-disabled') === 'true') return null;
    return o.getAttribute('data-variant');
  }

  form.addEventListener('submit', function (e) {
    // Block the add outright when no valid bag can accompany the handpan.
    if (noneAvailable || !selectedAvailable() || !selectedBagId()) {
      e.preventDefault(); e.stopPropagation();
      showError(noneAvailable ? msgNoneAvailable() : msgSoldOut());
      pending = null;
      return;
    }
    clearError();
    var bagId = selectedBagId();
    var hp = form.querySelector('[name="id"]');
    pending = bagId ? { bagId: bagId, handpanId: hp ? parseInt(hp.value, 10) : null, freeId: freeBagId() } : null;
    clearTimeout(pendingTimer); pendingTimer = setTimeout(function () { pending = null; }, 6000);
  }, true);

  document.addEventListener('theme:cart:error', function () { pending = null; });

  document.addEventListener('theme:cart:refresh', function () {
    if (working || !pending) return;
    var job = pending; pending = null; working = true; clearTimeout(pendingTimer);
    var bundleId = 'hp-' + Date.now();
    addBag(job.bagId, bundleId)
      .then(function () { return job.handpanId ? tagHandpanLine(job.handpanId, bundleId, job.freeId) : null; })
      .then(function () { clearError(); document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); })
      .catch(function (err) {
        console.warn('[bag-selector]', err);
        // Sold out / stock race: tell the customer instead of failing silently.
        // The handpan line stays untagged (no _default_bag), so bag-cart-guard
        // won't retry a variant that can't be added.
        if (err && err.status === 422) showError(msgSoldOut());
      })
      .then(function () { working = false; });
  });

  function addBag(variantId, bundleId) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _bundle: bundleId } }] })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          var err = new Error('[bag-selector] add failed: ' + (j.description || j.message || r.status));
          err.status = r.status;
          throw err;
        });
      }
      return r;
    });
  }

  // Tag the handpan line in place (_bundle + _default_bag) so bag-cart-guard.js
  // can re-add the free bag if its bag is later removed from the cart. Uses
  // /cart/change.js by line key — updates properties without removing the
  // line, so a failure here can't drop the handpan from the cart (see header).
  function tagHandpanLine(variantId, bundleId, freeId) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.variant_id === variantId; })[0];
      if (!line) return;
      var props = line.properties || {};
      props._bundle = bundleId;
      if (freeId) props._default_bag = String(freeId);
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
      });
    });
  }
})();
